import React, { Component } from 'react';

import './pdf.css';
import { jsPDF } from "jspdf";
import Moment from 'moment';

//import pptxgen from "pptxgenjs";
import Header from './Header';
import Footer from './Footer';
import ApiServices from "../../providers/ApiServices";
import Utilities from '../../global/Utilities';
import AuthService from '../../providers/AuthService';


class PDFReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            startDate: new Date(),
            endDate: new Date(),
            reportingManager: "",
            userName: "",
            subFilterName: "All",
            crop_hybrid: [],

            data: null,
            // data: {
            //     new_krishak: 87,
            //     new_prerak: 18,

            //     activity: {
            //         total_activity: 100,
            //         completed_activity: 75,
            //         individual_visit: {
            //             total_activity: 50,
            //             completed_activity: 40,
            //             sub_activity: [
            //                 { activity_name: "Sub Activity 1", total_activity: 10, completed_activity: 10 },
            //                 { activity_name: "Sub Activity 2", total_activity: 8, completed_activity: 5 },
            //                 { activity_name: "Sub Activity 3", total_activity: 5, completed_activity: 3 },
            //             ]
            //         },

            //         sample_distribution: {
            //             total_activity: 25,
            //             completed_activity: 15,
            //             sub_activity: [
            //                 { activity_name: "Sub Activity 1", total_activity: 10, completed_activity: 5 },
            //                 { activity_name: "Sub Activity 2", total_activity: 15, completed_activity: 10 }
            //             ]
            //         },

            //         group_meeting: {
            //             total_activity: 40,
            //             completed_activity: 20,
            //             sub_activity: [
            //                 { activity_name: "Sub Activity 1", total_activity: 10, completed_activity: 7 },
            //                 { activity_name: "Sub Activity 2", total_activity: 10, completed_activity: 5 }
            //             ]
            //         },

            //         sample_to_sale: {
            //             total_activity: 5,
            //             completed_activity: 5,
            //             sub_activity: [
            //                 { activity_name: "Sub Activity 1", total_activity: 10, completed_activity: 7 },
            //                 { activity_name: "Sub Activity 2", total_activity: 10, completed_activity: 10 }
            //             ]
            //         },
            //     },

            //     user_activity: {
            //         total_user: 40,
            //         active_user: 25,
            //         user_detail: [
            //             { user_name: "Suresh Patare", total_activity: 10, completed_activity: 0 },
            //             { user_name: "Amjat Hussain", total_activity: 30, completed_activity: 28 },
            //             { user_name: "Jollu Naveen", total_activity: 45, completed_activity: 44 },
            //             { user_name: "Ram Kishan", total_activity: 40, completed_activity: 34 },
            //             { user_name: "Jollu Naveen", total_activity: 35, completed_activity: 35 },
            //         ]
            //     },

            //     tehsil: {
            //         total_tehsil: 30,
            //         active_tehsil: 15,
            //         tehsil_detail: [
            //             { tehsil_name: "Tehsil One", total_activity: 50, completed_activity: 38 },
            //             { tehsil_name: "Tehsil Two", total_activity: 50, completed_activity: 10 },
            //             { tehsil_name: "Tehsil Three", total_activity: 50, completed_activity: 40 },
            //         ]
            //     },

            //     hybrid: [
            //         {
            //             hybrid_name: "Rice",
            //             total_hybrid: 8,
            //             active_hybrid: 6,
            //             hybrid_detail: [
            //                 { hybrid_name: "US1", total_hybrid: 30, active_hybrid: 28 },
            //                 { hybrid_name: "US2", total_hybrid: 25, active_hybrid: 23 },
            //                 { hybrid_name: "US3", total_hybrid: 30, active_hybrid: 27 },
            //                 { hybrid_name: "US4", total_hybrid: 29, active_hybrid: 26 },
            //                 { hybrid_name: "US5", total_hybrid: 40, active_hybrid: 20 },
            //                 { hybrid_name: "US6", total_hybrid: 25, active_hybrid: 23 },
            //                 { hybrid_name: "US7", total_hybrid: 29, active_hybrid: 27 },
            //             ]
            //         },
            //         {
            //             hybrid_name: "Musted",
            //             total_hybrid: 6,
            //             active_hybrid: 5,
            //             hybrid_detail: [
            //                 { hybrid_name: "US1", total_hybrid: 80, active_hybrid: 60 },
            //                 { hybrid_name: "US2", total_hybrid: 60, active_hybrid: 40 },
            //                 { hybrid_name: "US3", total_hybrid: 50, active_hybrid: 30 },
            //             ]
            //         },
            //     ],

            //     crop_hyrid: [
            //         {
            //             crop_name: "Rice",
            //             data: [
            //                 { tehsil_name: "Tehsil", hybrid: ["Hybrid One", "Hybrid Two", "Hybrid Three"] },
            //                 { tehsil_name: "Ahmedabad", hybrid: ["12/12", "20/34", "1/3"] },
            //                 { tehsil_name: "Surat", hybrid: ["12/12", "20/34", "15/23"] },
            //                 { tehsil_name: "Surat", hybrid: ["12/12", "20/34", "15/23"] },
            //                 { tehsil_name: "Surat", hybrid: ["12/12", "20/34", "15/23"] },
            //             ]
            //         },
            //         {
            //             crop_name: "Cotton",
            //             data: [
            //                 { tehsil_name: "Tehsil", hybrid: ["Hybrid One", "Hybrid Two", "Hybrid Three"] },
            //                 { tehsil_name: "Ahmedabad", hybrid: ["12/12", "20/34", "1/3"] },
            //                 { tehsil_name: "Surat", hybrid: ["12/12", "20/34", "115/233"] },
            //             ]
            //         }
            //     ]
            // },
        }
    }

    componentDidMount() {

    }


    savePDF = () => {
        const onSaveFile = this.props.onSaveFile;

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "px",
            format: 'a4',
        });
        //pdf.html(ReactDOMServer.renderToStaticMarkup(this.render()));
        //const htmlToConvert = renderToString(this.render());

        const input = document.getElementById('report');
        pdf.lineHeightProportion = 2;

        pdf.html(input, {
            callback: function (doc) {
                doc.save("dashboardReports.pdf");
                onSaveFile();
            }
        });

        // setTimeout(() => {
        //     this.props.onSaveFile();
        // }, 1000);
    }

    generatePDF(param) {
        //alert(param);
        this.getDashboardData(param);
    }

    getDashboardData = (params) => {
        this.setState({ isLoading: true });
        // var request = JSON.stringify({
        //     start_date: startDate,
        //     end_date: endDate,
        //     role_id: 0
        // });

        try {
            ApiServices.getDashboardData(JSON.stringify(params))
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data !== null) {
                            const session = AuthService.getSession();

                            this.setState({
                                data: data,
                                startDate: params?.start_date,
                                endDate: params?.end_date,
                                reportingManager: data?.reporting_manager?.name,
                                userName: session?.user?.name
                            }, () => {
                                //this.savePDF();
                                this.getDashboardDownloadData(params);
                            });
                        }

                    } else {
                        Utilities.LogPrint("Status", response.message);
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }

    getDashboardDownloadData = (params) => {
        this.setState({ isLoading: true });
        // var request = JSON.stringify({
        //     start_date: startDate,
        //     end_date: endDate,
        //     role_id: 0
        // });

        try {
            ApiServices.getDashboardDownloadData(JSON.stringify(params))
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data !== null) {
                            this.setState({
                                crop_hybrid: data,
                            }, () => {
                                this.savePDF();
                            });
                        }

                    } else {
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    this.setState({ isLoading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }


    showLoader(show) {
        this.setState({ isLoading: show });
    }


    formatDate = (date) => {
        return Moment(new Date(date)).format("DD/MM/YYYY HH:mm");
    }

    // For Activities Tab Functions
    getActivitiesPercent() {
        const { data } = this.state;
        const activity = data.activity;
        let total = activity.total_activity;
        if (total > 0) {
            let completed = activity.completed_activity;
            const percent = (completed * 100) / total;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    getTotalHeightMaxValue() {
        const { data } = this.state;
        const activity = data.activity;
        return Math.max(activity.individual_visit.total_activity,
            activity.sample_distribution.total_activity,
            activity.group_meeting.total_activity,
            activity.sample_to_sale.total_activity);
    }

    getActivityBarHeightValue(total) {
        if (total > 0) {
            const height = (total * 100) / this.getTotalHeightMaxValue();
            return Math.round(height) + "%";
        } else {
            return 0 + "%";
        }
    }

    getActivityFilledBarPercent(totalActivity, completedActivity) {
        const percent = (completedActivity * 100) / totalActivity;
        //Utilities.LogPrint("Filled", Math.round(percent) + "%");
        return Math.round(percent) + "%";
    }

    getActivityUnFilledBarPercent(totalActivity, completedActivity) {
        const percent = (completedActivity * 100) / totalActivity;
        return Math.round(100 - percent) + "%";
    }

    getActiveValue(max, active) {
        //const { total, achieve } = this.props;
        const percent = (active * 100) / max;
        return Math.round(percent) + "%";
    }

    getPendingValue(max, active) {
        //const { total, achieve } = this.props;
        const percent = (active * 100) / max;
        return Math.round(100 - percent) + "%";
    }


    // For User Tab Functions
    getActiveUsersPercent() {
        const { data } = this.state;
        const userActivity = data.user_activity;
        let totalUser = userActivity.total_user;
        if (totalUser > 0) {
            let activeUser = userActivity.active_user;
            const percent = (activeUser * 100) / totalUser;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    calculateUserMaxWidth() {
        const { data } = this.state;
        const userActivity = data.user_activity;
        let maxValue = Math.max.apply(Math, userActivity.user_detail.map(function (user) {
            return user.total_activity;
        }))
        return maxValue;
    }


    calculateBarWidth(total) {
        const totalWidth = (total * 100) / this.calculateUserMaxWidth();
        return totalWidth;
    }

    calculateCompletedBarWidth(totalActivity, completedActivity) {
        const width = this.calculateBarWidth(totalActivity);
        const percent = (completedActivity * width) / totalActivity;
        if (!Number.isNaN(percent)) {
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    calculateTotalBarWidth(totalActivity, completedActivity) {
        const width = this.calculateBarWidth(totalActivity);
        const percent = (completedActivity * width) / totalActivity;
        return Math.round(width - percent) + "%";
    }

    // For Hybrids Tab Functions
    getActiveHybridPercent(totalHybrid, activeHybrid) {
        if (totalHybrid > 0) {
            const percent = (activeHybrid * 100) / totalHybrid;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    getHybridMaxWidth(hybridDetail) {
        let maxValue = Math.max.apply(Math, hybridDetail.map(function (hybrid) {
            return hybrid.total_hybrid;
        }))
        return maxValue;
    }

    getHybridBarWidthValue(total, hybridDetail) {
        const totalWidth = (total * 100) / this.getHybridMaxWidth(hybridDetail);
        return totalWidth;
    }

    getFilledWidth(totalActivity, completedActivity, hybridDetail) {
        const width = this.getHybridBarWidthValue(totalActivity, hybridDetail);
        const percent = (completedActivity * width) / totalActivity;

        if (!Number.isNaN(percent)) {
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    getUnFilledWidth(totalActivity, completedActivity, hybridDetail) {
        const width = this.getHybridBarWidthValue(totalActivity, hybridDetail);
        const percent = (completedActivity * width) / totalActivity;
        return Math.round(width - percent) + "%";
    }

    renderUsersData = (users) => {
        return (
            <table className="override" style={{ margin: 'auto', fontSize: '15px', color: '#fff', marginTop: '10px', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                <tbody>
                    {
                        users?.map((item, i) => (
                            //item.total_activity > 0 ?
                            <tr key={i}>
                                <td style={{ height: '50px', fontWeight: 400, textAlign: 'right', paddingRight: '16px', fontSize: '11px' }}>{item.user_name}</td>
                                <td style={{ width: '80%' }}>
                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                        <div className={item.total_activity === item.completed_activity ? "progress-fill-bar" : ""} style={{ width: this.calculateCompletedBarWidth(item.total_activity, item.completed_activity), background: '#c9060a', textAlign: 'right', paddingRight: '8px', fontSize: '11px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                        <div style={{ width: this.calculateTotalBarWidth(item.total_activity, item.completed_activity), textAlign: 'right', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                        <span style={{ fontSize: '11px', lineHeight: '32px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )
    }

    renderUsers = () => {
        const { data } = this.state;
        const users = data?.user_activity?.user_detail;

        if (users.length > 6) {
            let splitUsers = [];
            var i, j, fixSizeUsers, chunk = 9;
            for (i = 6, j = users.length; i < j; i += chunk) {
                fixSizeUsers = users.slice(i, i + chunk);
                splitUsers.push({
                    users: fixSizeUsers,
                    count: fixSizeUsers.length
                })
            }
            //Utilities.LogPrint("Final Array", splitUsers);
            if (splitUsers.length > 0) {
                return (
                    splitUsers?.map((item, i) => (
                        <div style={{ height: "632px", width: "446px" }} key={i}>
                            <table style={{ height: '632px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                                <tbody>
                                    <Header title="User Wise - Activities" />
                                    {this.renderUsersData(item?.users)}
                                    <Footer />
                                </tbody>
                            </table>

                        </div>
                    )))
            }
        }
    }


    renderTehsils = () => {
        const { crop_hybrid } = this.state;
        const tehsils = crop_hybrid;
        if (tehsils !== null && tehsils.length > 0) {

            let newTehsilArray = [];
            let i, j, fixSizeArray, chunk = 12;

            for (const element of tehsils) {
                //Utilities.LogPrint("Element", element);
                for (i = 0, j = element?.data.length; i < j; i += chunk) {
                    fixSizeArray = element?.data.slice(i, i + chunk);
                    newTehsilArray.push({
                        crop_name: element.crop_name,
                        data: fixSizeArray,
                        count: fixSizeArray.length
                    })
                }
            }
            Utilities.LogPrint("Final Array", newTehsilArray);

            return (
                newTehsilArray?.map((item, i) => (
                    <div style={{ height: "631px", width: "446px" }} key={i}>
                        <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                            <tbody>
                                <Header title={`${item.crop_name} - Tehsil Wise`} />
                                <table className="details" style={{ border: '0.5px solid black', margin: 'auto', textAlign: 'center', width: '100%', fontSize: '11px', fontWeight: 500 }}>
                                    <tbody>
                                        {
                                            item?.data?.map((row, i) => (
                                                <tr style={{ border: '0.5px solid black' }} key={i}>
                                                    <td style={{ borderLeft: '0.5px solid black' }}>{row.tehsil_name}</td>
                                                    {row?.hybrid?.map((hybrid, i) => (
                                                        <td style={{ borderLeft: '0.5px solid black', padding: '8px' }}>{hybrid}</td>
                                                    ))}
                                                </tr>
                                            ))
                                        }
                                    </tbody>

                                </table>
                                <Footer />
                            </tbody>
                        </table>

                    </div>
                )))
        }

    }

    render() {
        const { role_name } = this.props;
        const { data, startDate, endDate, userName, reportingManager } = this.state;

        if (data !== null) {
            const individualVisit = data.activity?.individual_visit;
            const sampleDistribution = data.activity?.sample_distribution;
            const groupMeeting = data.activity?.group_meeting;
            const sampleToSale = data.activity?.sample_to_sale;

            const userActivity = data?.user_activity;
            const hybrid = data?.hybrid;

            return (
                <div id="report">
                    {/* Slide 1 */}
                    <div style={{ height: "631px", width: "446px" }}>
                        <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                            {/* header */}
                            <tbody>
                                <Header />

                                {/* main container */}
                                <tr>
                                    <td style={{ position: 'relative' }}>
                                        <img src="/assets/report-icons/slide1-bg.png" alt="" style={{ position: 'absolute', top: 0, width: '100%', height: '100%', left: 0, zIndex: -1 }} />
                                        <p style={{ fontSize: '21px', fontWeight: 600, color: '#ed7d31', marginLeft: '30%' }}>SAFAL 2.0 Report</p>
                                    </td>
                                </tr>
                                {/* footer */}
                                <Footer />
                            </tbody>
                        </table>
                    </div>

                    {/* Details */}
                    <div style={{ height: "631px", width: "446px" }}>
                        <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                            {/* header */}
                            <tbody>

                                <Header title="Details" />
                                {/* main container */}
                                <tr>
                                    <td>
                                        <table className="details" style={{ textAlign: 'center', width: '100%', fontSize: '14px', fontWeight: 500 }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ height: '50px' }}>
                                                        Downloaded By: {userName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ height: '50px' }}>
                                                        Reporting Manager: {reportingManager}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ height: '50px' }}>
                                                        Date of Generation: {this.formatDate(new Date())}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ height: '50px' }}>
                                                        Sub(based on filter selection): {role_name}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ height: '50px' }}>
                                                        Form Date: {Utilities.formatDate(startDate)}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ height: '50px' }}>
                                                        To Date: {Utilities.formatDate(endDate)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {/* footer */}
                                <Footer />
                            </tbody>
                        </table>
                    </div>

                    {/* Krishak & Prerak */}
                    <div style={{ height: "631px", width: "446px" }}>
                        <table id="slide3" style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                            {/* header */}
                            <tbody>
                                <Header title="Krishak_And_Prerak" />

                                {/* main container */}
                                <tr>
                                    <td>
                                        <table className="override" style={{ marginLeft: '30px', width: '50%', fontSize: '18px', fontWeight: 500, margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table className="krishak">
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <img src="/assets/report-icons/krishak_general_icon.png" alt="" style={{ height: '80px', width: '80px' }} />
                                                                    </td>
                                                                    <td>
                                                                        <p style={{ fontSize: '18px', margin: 0, fontWeight: 400 }}>Krishak</p>
                                                                        <p style={{ fontSize: '18px', margin: 0, marginTop: '10px', fontWeight: 700 }}>{data.new_krishak}</p>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="2" style={{ height: '30px' }}></td>
                                                                </tr>

                                                                <tr>
                                                                    <td>
                                                                        <img src="/assets/report-icons/krishak_prerak_icon.png" alt="" style={{ height: '80px', width: '80px' }} />
                                                                    </td>
                                                                    <td>
                                                                        <p style={{ fontSize: '18px', margin: 0, fontWeight: 400 }}>Prerak</p>
                                                                        <p style={{ fontSize: '18px', margin: 0, marginTop: '10px', fontWeight: 700 }}>{data.new_prerak}</p>
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {/* footer */}
                                <Footer />
                            </tbody>
                        </table>
                    </div>

                    {/* Activities */}
                    <div style={{ height: "631px", width: "446px" }}>
                        <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                            {/* header */}
                            <tbody>
                                <Header title="Activities" />

                                {/* main container */}
                                <tr>
                                    <td>
                                        <table className="override" style={{ fontWeight: 500, margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table style={{ fontSize: '18px', fontWeight: 500, width: '100%' }}>
                                                            <tbody><tr>
                                                                <td style={{ height: '40px', fontSize: '14px' }}>Activities Completed</td>
                                                                <td style={{ height: '40px', fontSize: '14px', textAlign: 'right' }}>{data?.activity?.completed_activity}/{data?.activity?.total_activity}</td>
                                                            </tr>
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                        <div style={{ backgroundColor: '#e9ecef', overflow: 'hidden', height: '32px', borderRadius: '8px' }}>
                                                                            <div style={{ width: this.getActivitiesPercent(), height: '100%', fontSize: '14px', fontWeight: 500, backgroundColor: 'rgba(201,6,10,1)', textAlign: 'right', padding: '5px', color: '#fff', boxSizing: 'border-box' }}>{this.getActivitiesPercent()}</div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>
                                                        <table style={{ marginTop: '10px', height: '340px', padding: '50px 90px 50px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <ul style={{ display: 'flex', width: '100%', listStyle: 'none', height: '100%', marginBottom: 0, alignItems: 'flex-end', padding: '67px 0 0' }}>
                                                                            <li style={{ width: '100%', padding: '0 10px', textAlign: 'center', fontSize: '18px', fontWeight: 500, height: '100%', position: 'relative' }}>
                                                                                <span style={{ bottom: `calc(${this.getActivityBarHeightValue(individualVisit.total_activity)} + 33px)`, position: 'absolute', left: 0, width: '100%', fontSize: '14px' }}>{individualVisit.completed_activity} / {individualVisit.total_activity}</span>
                                                                                <div style={{ height: this.getActivityBarHeightValue(individualVisit.total_activity), position: 'absolute', bottom: '30px', left: '10px', width: 'calc(100% - 20px)', boxShadow: '5.4px 5.9px 14.7px 1.3px rgb(0 0 0 / 10%)', borderRadius: '7px', overflow: 'hidden' }}>
                                                                                    <div style={{ height: this.getActivityUnFilledBarPercent(individualVisit.total_activity, individualVisit.completed_activity), backgroundColor: '#fff' }} />
                                                                                    <div style={{ height: this.getActivityFilledBarPercent(individualVisit.total_activity, individualVisit.completed_activity), backgroundColor: 'rgba(254,213,7,1)' }} />
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', position: 'absolute', bottom: '5px', left: 0, color: '#fff', width: '100%' }}>IV</div>
                                                                            </li>
                                                                            <li style={{ width: '100%', padding: '0 10px', textAlign: 'center', fontSize: '18px', fontWeight: 500, height: '100%', position: 'relative' }}>
                                                                                <span style={{ bottom: `calc(${this.getActivityBarHeightValue(sampleDistribution.total_activity)} + 33px)`, position: 'absolute', left: 0, width: '100%', fontSize: '14px' }}>{sampleDistribution.completed_activity} / {sampleDistribution.total_activity}</span>
                                                                                <div style={{ height: this.getActivityBarHeightValue(sampleDistribution.total_activity), position: 'absolute', bottom: '30px', left: '10px', width: 'calc(100% - 20px)', boxShadow: '5.4px 5.9px 14.7px 1.3px rgb(0 0 0 / 10%)', borderRadius: '7px', overflow: 'hidden' }}>
                                                                                    <div style={{ height: this.getActivityUnFilledBarPercent(sampleDistribution.total_activity, sampleDistribution.completed_activity), backgroundColor: '#fff' }} />
                                                                                    <div style={{ height: this.getActivityFilledBarPercent(sampleDistribution.total_activity, sampleDistribution.completed_activity), backgroundColor: '#9e7e43' }} />
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', position: 'absolute', bottom: '5px', left: 0, color: '#fff', width: '100%' }}>SD</div>
                                                                            </li>
                                                                            <li style={{ width: '100%', padding: '0 10px', textAlign: 'center', fontSize: '18px', fontWeight: 500, height: '100%', position: 'relative' }}>
                                                                                <span style={{ bottom: `calc(${this.getActivityBarHeightValue(groupMeeting.total_activity)} + 33px)`, position: 'absolute', left: 0, width: '100%', fontSize: '14px' }}>{groupMeeting.completed_activity} / {groupMeeting.total_activity}</span>
                                                                                <div style={{ height: this.getActivityBarHeightValue(groupMeeting.total_activity), position: 'absolute', bottom: '30px', left: '10px', width: 'calc(100% - 20px)', boxShadow: '5.4px 5.9px 14.7px 1.3px rgb(0 0 0 / 10%)', borderRadius: '7px', overflow: 'hidden' }}>
                                                                                    <div style={{ height: this.getActivityUnFilledBarPercent(groupMeeting.total_activity, groupMeeting.completed_activity), backgroundColor: '#fff' }} />
                                                                                    <div style={{ height: this.getActivityFilledBarPercent(groupMeeting.total_activity, groupMeeting.completed_activity), backgroundColor: '#2599fe' }} />
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', position: 'absolute', bottom: '5px', left: 0, color: '#fff', width: '100%' }}>GM</div>
                                                                            </li>
                                                                            <li style={{ width: '100%', padding: '0 10px', textAlign: 'center', fontSize: '18px', fontWeight: 500, height: '100%', position: 'relative' }}>
                                                                                <span style={{ bottom: `calc(${this.getActivityBarHeightValue(sampleToSale.total_activity)} + 33px)`, position: 'absolute', left: 0, width: '100%', fontSize: '14px' }}>{sampleToSale.completed_activity} / {sampleToSale.total_activity}</span>
                                                                                <div style={{ height: this.getActivityBarHeightValue(sampleToSale.total_activity), position: 'absolute', bottom: '30px', left: '10px', width: 'calc(100% - 20px)', boxShadow: '5.4px 5.9px 14.7px 1.3px rgb(0 0 0 / 10%)', borderRadius: '7px', overflow: 'hidden' }}>
                                                                                    <div style={{ height: this.getActivityUnFilledBarPercent(sampleToSale.total_activity, sampleToSale.completed_activity), backgroundColor: '#fff' }} />
                                                                                    <div style={{ height: this.getActivityFilledBarPercent(sampleToSale.total_activity, sampleToSale.completed_activity), backgroundColor: '#10823c' }} />
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', position: 'absolute', bottom: '5px', left: 0, color: '#fff', width: '100%' }}>S2S</div>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr >
                                                            </tbody >
                                                        </table >
                                                    </td >
                                                </tr >
                                            </tbody >
                                        </table >
                                    </td >
                                </tr >
                                {/* footer */}
                                < Footer />
                            </tbody >
                        </table >
                    </div >

                    {/* Individual Visit - Drill Down */}
                    {
                        individualVisit.sub_activity?.length > 0 ?
                            <div style={{ height: "631px", width: "446px" }}>
                                <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                                    <tbody>
                                        <Header title="Individual Visit - Drill Down" />
                                        <table className="override" style={{ marginLeft: '30px', fontSize: '18px', fontWeight: 500, margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table style={{ fontSize: '18px', color: '#fff', marginTop: '10px', height: 'auto', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                            <tbody>
                                                                {
                                                                    individualVisit.sub_activity?.map((item, i) => (
                                                                        <tr key={i}>
                                                                            <td className="progress-style" style={{ fontWeight: 400, textAlign: 'right', paddingRight: '15px', height: '56px' }}>{item.activity_name}</td>
                                                                            <td style={{ width: '80%' }}>

                                                                                {item.total_activity !== item.completed_activity ?
                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity), background: 'rgba(254,213,7,1)', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <div style={{ width: this.getPendingValue(item.total_activity, item.completed_activity), textAlign: 'right', fontSize: '15px', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                                                                        <span className="progress-style" style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div> :

                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ borderRadius: '0 7px 7px 0', width: this.getActiveValue(item.total_activity, item.completed_activity), background: 'rgba(254,213,7,1)', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <span className="progress-style" style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <Footer />
                                    </tbody>
                                </table>

                            </div> : null
                    }

                    {/* Sample Distribution - Drill Down */}

                    {
                        sampleDistribution.sub_activity?.length > 0 ?
                            <div style={{ height: "631px", width: "446px" }}>
                                <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                                    <tbody>
                                        <Header title="Sample Distribution - Drill Down" />
                                        <table className="override" style={{ fontSize: '18px', fontWeight: 500, margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table style={{ fontSize: '14px', color: '#fff', marginTop: '10px', height: 'auto', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                            <tbody>
                                                                {
                                                                    sampleDistribution.sub_activity?.map((item, i) => (
                                                                        <tr key={i}>
                                                                            <td style={{ fontWeight: 400, fontSize: "11px", textAlign: 'right', paddingRight: '15px', height: '56px' }}>{item.activity_name}</td>
                                                                            <td style={{ width: '80%' }}>
                                                                                {item.total_activity !== item.completed_activity ?

                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity), background: '#9e7e43', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <div style={{ width: this.getPendingValue(item.total_activity, item.completed_activity), textAlign: 'right', fontSize: '15px', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                                                                        <span style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div> :
                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ borderRadius: '0 7px 7px 0', width: this.getActiveValue(item.total_activity, item.completed_activity), background: '#9e7e43', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <span style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div>
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <Footer />
                                    </tbody>
                                </table>

                            </div> : null
                    }

                    {/* Group Meeting - Drill Down */}

                    {
                        groupMeeting.sub_activity?.length > 0 ?
                            <div style={{ height: "631px", width: "446px" }}>
                                <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                                    <tbody>
                                        <Header title="Group Meeting - Drill Down" />
                                        <table className="override" style={{ marginLeft: '30px', width: '80%', fontSize: '18px', fontWeight: 500, margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table style={{ fontSize: '14px', color: '#fff', marginTop: '10px', height: 'auto', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                            <tbody>
                                                                {
                                                                    groupMeeting.sub_activity?.map((item, i) => (
                                                                        <tr key={i}>
                                                                            <td style={{ fontWeight: 400, fontSize: "11px", textAlign: 'right', paddingRight: '15px', height: '56px' }}>{item.activity_name}</td>
                                                                            <td style={{ width: '80%' }}>
                                                                                {item.total_activity !== item.completed_activity ?

                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity), background: '#2599fe', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <div style={{ width: this.getPendingValue(item.total_activity, item.completed_activity), textAlign: 'right', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                                                                        <span className="progress-style" style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div> :
                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ borderRadius: '0 7px 7px 0', width: this.getActiveValue(item.total_activity, item.completed_activity), background: '#2599fe', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <span className="progress-style" style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div>

                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <Footer />
                                    </tbody>
                                </table>

                            </div> : null
                    }

                    {/* S2S- Drill Down */}

                    {
                        sampleToSale.sub_activity?.length > 0 ?
                            <div style={{ height: "631px", width: "446px" }}>
                                <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                                    <tbody>
                                        <Header title="Sample To Sale - Drill Down" />
                                        <table className="override" style={{ marginLeft: '30px', width: '80%', fontSize: '18px', fontWeight: 500, margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table style={{ fontSize: '14px', color: '#fff', marginTop: '10px', height: 'auto', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                            <tbody>
                                                                {
                                                                    sampleToSale.sub_activity?.map((item, i) => (
                                                                        <tr key={i}>
                                                                            <td style={{ fontWeight: 400, fontSize: "11px", textAlign: 'right', paddingRight: '15px', height: '56px' }}>{item.activity_name}</td>
                                                                            <td style={{ width: '80%' }}>

                                                                                {item.total_activity !== item.completed_activity ?
                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ width: this.getActiveValue(item.total_activity, item.completed_activity), background: '#10823c', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <div style={{ width: this.getPendingValue(item.total_activity, item.completed_activity), textAlign: 'right', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                                                                        <span className="progress-style" style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div> :
                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div className="progress-style" style={{ borderRadius: '0 7px 7px 0', width: this.getActiveValue(item.total_activity, item.completed_activity), background: '#10823c', textAlign: 'right', paddingRight: '5px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                                        <span className="progress-style" style={{ lineHeight: '30px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                                    </div>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <Footer />
                                    </tbody>
                                </table>

                            </div> : null
                    }

                    {/* User Wise Activity */}
                    <div style={{ height: "631px", width: "446px" }}>
                        <table style={{ height: '631px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                            <tbody>
                                <Header title="User Wise - Activities" />
                                <table className="override" style={{ fontSize: '16px', fontWeight: 500, margin: 'auto' }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table style={{ fontSize: '14px', fontWeight: 500, width: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ height: '40px' }}>Active Users</td>
                                                            <td style={{ height: '40px', textAlign: 'right' }}>{userActivity?.active_user}/{userActivity?.total_user}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={2}>
                                                                <div style={{ backgroundColor: '#e9ecef', overflow: 'hidden', height: '32px', borderRadius: '8px' }}>
                                                                    <div style={{ width: this.getActiveUsersPercent(), height: '100%', fontWeight: 500, background: 'rgba(201,6,10,1)', textAlign: 'right', padding: '5px', color: '#fff', boxSizing: 'border-box' }}>
                                                                        {this.getActiveUsersPercent()}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <table style={{ fontSize: '15px', color: '#fff', marginTop: '10px', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={2} style={{ padding: '8px', fontWeight: 500 }}>Activities Completed/Planned by Users</td>
                                                        </tr>
                                                        {
                                                            userActivity?.user_detail.slice(0, 6).map((item, i) => (
                                                                // item.total_activity > 0 ?
                                                                <tr key={i}>
                                                                    <td style={{ height: '50px', fontWeight: 400, textAlign: 'right', paddingRight: '16px', fontSize: '11px' }}>{item.user_name}</td>
                                                                    <td style={{ width: '80%' }}>
                                                                        <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                            <div className={item.total_activity === item.completed_activity ? "progress-fill-bar" : ""} style={{ width: this.calculateCompletedBarWidth(item.total_activity, item.completed_activity), background: '#c9060a', textAlign: 'right', paddingRight: '8px', fontSize: '11px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{item.completed_activity}</div>
                                                                            <div style={{ width: this.calculateTotalBarWidth(item.total_activity, item.completed_activity), textAlign: 'right', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                                                            <span style={{ fontSize: '11px', lineHeight: '32px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{item.total_activity}</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <Footer />
                            </tbody>
                        </table>

                    </div>

                    {/* More then 6 Users */}
                    {this.renderUsers()}

                    {/* Hybrids */}
                    {
                        hybrid?.length > 0 ?
                            hybrid?.map((item, i) => (
                                <div style={{ height: "632px", width: "446px" }} key={i}>
                                    <table style={{ height: '632px', maxWidth: '1180px', width: '100%', boxShadow: '0px 0px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
                                        <tbody>
                                            <Header title={`${item.hybrid_name} - Hybrids Activities`} />
                                            <table className="override" style={{ marginLeft: '30px', width: '80%', fontSize: '18px', fontWeight: 500, margin: 'auto' }}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <table style={{ fontSize: '14px', fontWeight: 500, width: '100%' }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ height: '40px' }}>Active Hybrids</td>
                                                                        <td style={{ height: '40px', textAlign: 'right' }}>{item?.active_hybrid}/{item?.total_hybrid}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={2}>
                                                                            <div style={{ backgroundColor: '#e9ecef', overflow: 'hidden', height: '32px', borderRadius: '8px' }}>
                                                                                <div style={{ width: this.getActiveHybridPercent(item?.total_hybrid, item?.active_hybrid), height: '100%', fontWeight: 500, background: 'rgba(201,6,10,1)', textAlign: 'right', padding: '5px', color: '#fff', boxSizing: 'border-box' }}>
                                                                                    {this.getActiveHybridPercent(item?.total_hybrid, item?.active_hybrid)}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <table style={{ fontSize: '11px', color: '#fff', marginTop: '10px', height: 'auto', padding: '30px 90px 30px', borderRadius: '7px', backgroundColor: '#78909c', width: '100%' }}>
                                                                <tbody>
                                                                    {
                                                                        item?.hybrid_detail?.map((hybrid, i) => (
                                                                            <tr key={i}>
                                                                                <td style={{ fontWeight: 400, textAlign: 'right', paddingRight: '15px', height: '50px' }}>{hybrid.hybrid_name}</td>
                                                                                <td style={{ width: '80%' }}>
                                                                                    <div style={{ height: '28px', borderRadius: '8px', overflow: 'hidden', lineHeight: 0, fontSize: '0.75rem', display: 'flex', backgroundColor: 'transparent' }}>
                                                                                        <div style={{ width: this.getFilledWidth(hybrid.total_hybrid, hybrid.active_hybrid, item.hybrid_detail), background: '#c9060a', textAlign: 'right', paddingRight: '8px', fontSize: '11px', fontWeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden', whiteSpace: 'nowrap', color: '#fff' }}>{hybrid.active_hybrid}</div>
                                                                                        <div style={{ width: this.getUnFilledWidth(hybrid.total_hybrid, hybrid.active_hybrid, item.hybrid_detail), textAlign: 'right', fontWeight: 500, color: '#344850', backgroundColor: '#fff', borderRadius: '0 7px 7px 0' }} />
                                                                                        <span style={{ fontSize: '11px', lineHeight: '32px', fontWeight: 500, paddingLeft: '6px', paddingRight: '6px', color: '#344850' }}>{hybrid.total_hybrid}</span>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <Footer />
                                        </tbody>
                                    </table>

                                </div>
                            )) : null
                    }

                    {/* Tehsil */}
                    {this.renderTehsils()}

                </div >
            )
        } else {
            return null;
        }

    }

}

export default PDFReport;